export const INITIAL_LIVES = 3;
